/** Проверки правдоподобности дат (ТЗ FR-10). */

import type { IsoDate } from '../types/common.js';

export function parseIso(value: IsoDate | null | undefined): Date | null {
  if (!value) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!m) return null;
  const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const date = new Date(Date.UTC(y, mo - 1, d));
  if (date.getUTCFullYear() !== y || date.getUTCMonth() !== mo - 1 || date.getUTCDate() !== d) return null;
  return date;
}

export function isPast(value: IsoDate | null, now = new Date()): boolean {
  const d = parseIso(value);
  return d !== null && d.getTime() <= now.getTime();
}

/** Полных лет на дату `at`. */
export function ageAt(birthDate: IsoDate | null, at = new Date()): number | null {
  const b = parseIso(birthDate);
  if (!b) return null;
  let age = at.getUTCFullYear() - b.getUTCFullYear();
  const monthDiff = at.getUTCMonth() - b.getUTCMonth();
  if (monthDiff < 0 || (monthDiff === 0 && at.getUTCDate() < b.getUTCDate())) age--;
  return age;
}

export function isAdult(birthDate: IsoDate | null, at = new Date()): boolean {
  const age = ageAt(birthDate, at);
  return age !== null && age >= 18;
}

export function isBefore(a: IsoDate | null, b: IsoDate | null): boolean {
  const da = parseIso(a);
  const db = parseIso(b);
  if (!da || !db) return false;
  return da.getTime() < db.getTime();
}

/**
 * Сделка попадает в трёхлетний период, предшествующий дате подачи (ТЗ п. 5.2.8).
 * Выход за период не блокирует генерацию, а даёт предупреждение (раздел 6.8).
 */
export function isWithinThreeYears(dealDate: IsoDate | null, filingDate: IsoDate | null, now = new Date()): boolean {
  const deal = parseIso(dealDate);
  if (!deal) return true; // пустую дату проверяет обязательность поля, а не это правило
  const filing = parseIso(filingDate) ?? now;
  const boundary = new Date(Date.UTC(filing.getUTCFullYear() - 3, filing.getUTCMonth(), filing.getUTCDate()));
  return deal.getTime() >= boundary.getTime() && deal.getTime() <= filing.getTime();
}

export function todayIso(now = new Date()): IsoDate {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
